// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thermomix-match {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.thermomix-match .ingredient {
  padding: 8px 12px;
  box-sizing: border-box;
}
.thermomix-match .ingredient .kiwi-icon {
  font-size: 32px;
  min-width: 32px;
  color: var(--kiwi-accent-text);
}
.thermomix-match .ingredient .ingredient-name {
  font-family: var(--font-primary);
  font-size: var(--font-bigger);
}
.thermomix-match .match-score {
  background-color: rgba(var(--kiwi-text-rgb), 0.07);
  padding-top: 2px;
  padding-bottom: 2px;
}
.thermomix-match .decision .remember-item {
  --background: transparent;
  --padding-start: 0;
  --inner-padding-end: 0;
  font-family: var(--font-secondary);
  font-size: var(--font-small);
}`, "",{"version":3,"sources":["webpack://./src/app/modals/thermomix-match-modal/thermomix-match-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,iBAAA;EACA,sBAAA;AACJ;AACI;EACE,eAAA;EACA,eAAA;EACA,8BAAA;AACN;AAEI;EACE,gCAAA;EACA,6BAAA;AAAN;AAIE;EACE,kDAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAMI;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;AAJN","sourcesContent":[".thermomix-match {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .ingredient {\n    padding: 8px 12px;\n    box-sizing: border-box;\n\n    .kiwi-icon {\n      font-size: 32px;\n      min-width: 32px;\n      color: var(--kiwi-accent-text);\n    }\n\n    .ingredient-name {\n      font-family: var(--font-primary);\n      font-size: var(--font-bigger);\n    }\n  }\n\n  .match-score {\n    background-color: rgba(var(--kiwi-text-rgb), 0.07);\n    padding-top: 2px;\n    padding-bottom: 2px;\n  }\n\n  .decision {\n    .remember-item {\n      --background: transparent;\n      --padding-start: 0;\n      --inner-padding-end: 0;\n      font-family: var(--font-secondary);\n      font-size: var(--font-small);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
